import { Directive, ElementRef, HostListener } from '@angular/core';
@Directive({
  selector: '[appTwoDigitDecimaNumber]'
})
export class TwoDigitDecimaNumberDirective {
  //private regex: RegExp = new RegExp(/^\d*\.?\d{0,1}$/g);
  private regex: RegExp = new RegExp(/^\d+(\.\d{1,2})?$/);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    //console.log(this.el.nativeElement.value);
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    //console.log(current);
    const position = this.el.nativeElement.selectionStart;
    //console.log(position);
    //const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    //console.log(next);
    const next: string = current + event.key;

    var regexp = /^\d+(\.\d{1,2})?$/;
    if(!regexp.test(next) && !(event.key == '.'))
    {
      event.preventDefault();
    }
    // if (next && !String(next).match(this.regex)) {
    //   event.preventDefault();
    // }
  }
}